<template>
  <v-form ref="comboProductEditForm" v-model="valid">
    <div class="back-btn" @click="$router.push({name: 'combo-product-index'})">
      <svg width="56" height="56" viewBox="0 0 56 56" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M36 27H23.83L29.42 21.41L28 20L20 28L28 36L29.41 34.59L23.83 29H36V27Z" fill="#8C959D"/>
      </svg>
    </div>
    <v-row>
      <v-col cols="12">
        <h1>{{this.id ? 'Редактирование сета' : 'Создание сета'}}</h1>
      </v-col>
      <v-col  cols="12" sm="5" md="4" xl="3">
        <v-text-field
            v-model="comboProduct.iiko_id"
            label="Iiko id блюда"
            :rules="[rules.required]"
            required
            outlined
        ></v-text-field>
        <v-text-field
            v-model="comboProduct.glovo_iiko_id"
            label="Glovo Iiko id блюда"
            required
            outlined
        ></v-text-field>
        <h3>Добавить позиции:</h3>
        <v-text-field
            v-for="(item, index) in comboProduct.combo_products"
            v-model="comboProduct.combo_products[index]"
            label="Iiko id позиции которую нужно добавит"
            :rules="[rules.required]"
            required
            outlined
            append-outer-icon="mdi-close"
            @click:append-outer="removeItem(index)"
        ></v-text-field>
        <v-btn color="primary" @click="comboProduct.combo_products.push('')">+</v-btn>
        <v-divider class="ma-4"/>
        <v-btn v-if="id" @click="update">Сохранить</v-btn>
        <v-btn v-else @click="create">Создать</v-btn>
      </v-col>
      <v-snackbar
          v-model="snackbar"
          :timeout="timeout"
          :color="snackbarColor"
          right
          top
      >
        {{ snackbarText }}
      </v-snackbar>
    </v-row>
  </v-form>
</template>

<script>
// @ is an alias to /src
import ComboProductService from './../../api/ComboProductService'
import ProductService from "@/api/ProductService";

export default {
  name: 'ComboProductEdit',
  props: {
    id: {
      default: null,
    }
  },
  components: {},
  data: () => ({
    snackbar: false,
    timeout: 2000,
    snackbarText: '',
    snackbarColor: '',
    rules: {
      required: value => !!value || 'Нужно заполнить',
      requiredSelect: [(v) => !!v.id || 'Нужно заполнить'],
    },
    valid: true,
    tab: '',
    tabLang: '',
    certificate: null,
    comboProduct: {
      iiko_id: '',
      glovo_iiko_id: '',
      combo_products: [],
    },
    loading: true,
    loadingButton: false,
    isLoading: false,
    products: [],
    search: null
  }),
  watch: {
    search (val) {
      if (this.isLoading) return

      this.isLoading = true

      ProductService.findByName({word: this.search}).then(response => {
        this.products = response.data;
      }).finally(response => {
        this.isLoading = false
      });
    },
  },
  mounted() {
    if(this.id) {
      ComboProductService.get(this.id)
          .then(response => {
            this.comboProduct = response.data;
            this.loading = false
          });
    }
  },
  methods: {
    removeItem(index){
      this.comboProduct.combo_products.splice(index, 1)
    },
    validate() {
      this.$refs.comboProductEditForm.validate()

    },

    update(){
      this.validate()
      if(!this.valid){
        return false
      }

      this.loadingButton = true;
      let formData = this.getData();

      ComboProductService.update(this.comboProduct.id, formData).then(response => {
        this.snackbar = true;
        this.snackbarText = 'Успешно обновлено';
        this.snackbarColor = 'success';
      }).catch(error => {
        this.snackbar = true;
        this.snackbarText = 'Ошибка при обновлении';
        this.snackbarColor = 'error';
      }).finally(() => {
        this.loadingButton = false
      })
    },
    create(){
      this.validate()
      if(!this.valid){
        return false
      }
      this.loadingButton = true;
      var formData = this.getData();

      ComboProductService.create(formData).then(response => {
        this.$router.push({ name: 'combo-product-edit', params: { id: response.data.id } })
        this.comboProduct.id = response.id
        this.snackbar = true;
        this.snackbarText = 'Аккаунт создан';
        this.snackbarColor = 'success';
      }).catch(error => {
        this.snackbar = true;
        this.snackbarText = 'Ошибка при создании';
        this.snackbarColor = 'error';
      }).finally(() => {
        this.loadingButton = false
      })
    },
    getData() {
      return {
        iiko_id: this.comboProduct.iiko_id,
        glovo_iiko_id: this.comboProduct.glovo_iiko_id,
        combo_products: this.comboProduct.combo_products
      }
    }
  },
}
</script>

<style scoped lang="scss">
.comboProduct-images .v-image{
  max-height: 374px;
}
.mobile{
  width: 300px;
  height: 300px;
  margin-bottom: 24px;
}
.comboProduct{
  position: relative;
  &:before{
    content: "";
    padding-top: 100%;
    display: block;
  }

  .content{
    position: absolute;
    width: 100%;
    left: 0;
    top: 0;
    height: 100%;
    background-color: #F8FBFF;
    border-right-style: 3px;
    .img{
      height: 3.541vw;
      margin-top: .83vw;
    }
    .name{
      margin-top: .72vw;
      text-align: center;
      color: #8C959D;
    }
  }
}
</style>
